function Suriname({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_2227)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#F0F0F0"/>
  <path d="M31.0047 10.4346H0.995125C0.352063 12.1679 0 14.0426 0 15.9998C0 17.9569 0.352063 19.8317 0.995125 21.5649H31.0048C31.648 19.8317 32 17.9569 32 15.9998C32 14.0426 31.648 12.1679 31.0047 10.4346Z" fill="#A2001D"/>
  <path d="M16.0464 31.9995C21.5265 31.9995 26.3625 29.2437 29.2461 25.043H2.84668C5.73031 29.2437 10.5662 31.9995 16.0464 31.9995Z" fill="#6DA544"/>
  <path d="M16.0464 0C21.5265 0 26.3625 2.75575 29.2461 6.9565H2.84668C5.73031 2.75575 10.5662 0 16.0464 0Z" fill="#6DA544"/>
  <path d="M15.9999 10.4346L17.3813 14.6858H21.8516L18.2351 17.3136L19.6165 21.5649L15.9999 18.9375L12.3834 21.5649L13.7649 17.3136L10.1483 14.6858H14.6186L15.9999 10.4346Z" fill="#FFDA44"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Suriname;
